var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.label,"append-outer-icon":"fas fa-file-alt"},on:{"click:append-outer":_vm.showDocumentLibary},model:{value:(_vm.the_url),callback:function ($$v) {_vm.the_url=$$v},expression:"the_url"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }